module.exports = __webpack_public_path__ + "img/pipeixin.2c5f2828.png";